<template>
  <div>
    <div id="cover-image">
      <img
        class="cover"
        :src="require('@/assets/background-parent-profile.png')"
        alt
      />
      <div id="img-frame" class="text-center mb-1">
        <img
          class="photo"
          v-lazy="{
            src: photo,
            error: onError(),
            loading: require('@/assets/Rolling-1s-200px_2.svg')
          }"
        />
      </div>
    </div>
    <div class="text-center">
      <span>{{ profile ? profile.parent_id : '-' }}</span>
      <h3
        class="text-center ts-font-bold ts-text-lg mt-2 mb-0 text-uppercase text-primary"
      >
        {{ profile ? profile.mother_name_en : '-' }}
      </h3>
    </div>
    <ts-card-wrapper>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <span>
            {{ $t('homePage.nameKh') }}
          </span>
          <p class="pull-right">
            {{ profile.mother_name_kh ? profile.mother_name_kh : '-' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.dateOfBirth') }}
          </span>
          <p class="pull-right">
            {{ profile.mother_dob ? profile.mother_dob : '-' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.nationality') }}
          </span>
          <p class="pull-right">
            {{
              profile.mother_nationality
                ? profile.mother_nationality.nationality
                : '-'
            }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.religion') }}
          </span>
          <p class="pull-right">
            {{ profile.mother_religion ? profile.mother_religion : '-' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{ $t('homePage.phoneNumber') }}
          </span>
          <p class="pull-right">
            {{ profile.mother_phone1 ? profile.mother_phone1 : '-' }} /
            {{ profile.mother_phone2 ? profile.mother_phone2 : '-' }}
          </p>
        </li>
      </ul>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'mother-profile',
  data() {
    return {
      saving: false,
      fileChange: false,
      file: require('@/assets/user_default.png')
    }
  },
  computed: {
    ...mapState('home/parent', ['profile']),
    photo() {
      if (this.profile.mother_photo) {
        return this.profile.mother_photo
      }
      return this.file
    }
  },
  methods: {
    onError() {
      event ? (event.target.src = this.file) : ''
    }
  }
}
</script>
<style lang="css" scoped>
.cover {
  opacity: 0.2;
}
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.list-group-item {
  border: none !important;
  padding: 10px 0 10px 0;
  margin: 0;
  border-top: 1px solid #eee !important;
}
.list-group-item.address {
  border: none !important;
  padding-top: 2px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -30%;
}
#img-frame .photo {
  width: 146px;
  object-fit: contain;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
